import { render, staticRenderFns } from "./DemoBuilder.vue?vue&type=template&id=1ac7b29b"
import script from "./DemoBuilder.vue?vue&type=script&lang=js"
export * from "./DemoBuilder.vue?vue&type=script&lang=js"
import style0 from "./DemoBuilder.vue?vue&type=style&index=0&id=1ac7b29b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports